// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-spinner {
  position: fixed; /* or absolute */
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login-callback/login-callback.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA,EAAA,gBAAA;EACC,QAAA;EACA,SAAA;AACF","sourcesContent":[".fa-spinner{\n\tposition: fixed; /* or absolute */\n  top: 50%;\n  left: 50%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
